<template>
    <div
        v-if="hasGetData"
        class="wework-account-box"
    >
        <v-popmenu
            ref="accountMenu"
            :inline="true"
            :options="accountMenuOptions"
            @select="onMenuSelect"
            clazz="wework-account-menu-pop"
            placement="bottom-end"
        >
            <template
                slot="item"
                slot-scope="prop"
            >
                <span
                    :class="is_probation ? 'wework-account-menu-forbid' : 'wework-account-menu-forbid disabled'"
                >
                    {{ prop.item.text }}
                </span>
                <span
                    v-tip:unbindTip.hover.delay
                    class="question-mark"
                />
                <v-tip
                    ref="unbindTip"
                    kind="small"
                    placement="top"
                >
                    <div style="width: 240px">
                        <i18n-t path="购买激活{license}后，不能再解绑当前企业微信主体账号" tag="span">
                            <a
                                slot="license"
                                href="https://developer.work.weixin.qq.com/document/path/95652"
                                target="_blank"
                            >{{ $t('企业微信接口调用许可账号') }}</a>
                        </i18n-t>
                    </div>
                </v-tip>
            </template>
        </v-popmenu>
        <v-popmenu
            ref="contactMenu"
            :inline="true"
            :options="contactMenuOptions"
            @select="onMenuSelect"
            clazz="wework-account-menu-pop"
            placement="bottom-end"
        />
        <v-popmenu
            ref="conversationMenu"
            :inline="true"
            :options="conversationOptions"
            @select="onMenuSelect"
            clazz="wework-account-menu-pop"
            placement="bottom-end"
        />
        <v-tip
            ref="notverTip"
            :offset="11"
            kind="small"
            placement="top-start"
        >
            <div style="width: 125px">
                {{ $t('企业微信未验证或未绑定视频号，仅可接待100位客户') }}
            </div>
        </v-tip>
        <v-page-header level="section" :title="$t('企业微信账号')" />
        <div class="wework-account-card">
            <v-icon
                name="wework"
                class="wework-account-ico"
            />
            <div class="wework-account-res">
                <p class="wework-account-tit">
                    {{ $t('已绑定企业微信') }}
                </p>
                <p class="wework-account-name">
                    <b>{{ accountInfo.corp_name }}</b>
                    <span
                        v-if="accountInfo.isVerify"
                        class="wework-account-tag wework-account-tag-hasver"
                    >{{ $t('已验证') }}</span>
                    <span
                        v-else
                        v-tip:notverTip
                        class="wework-account-tag wework-account-tag-notver"
                    >
                        <v-icon name="notver" />{{ $t('未验证') }}
                    </span>
                </p>
                <p
                    v-if="accountInfo.corp_id"
                    class="wework-account-corpId"
                >
                    {{ $t('企业ID为') }} {{ accountInfo.corp_id }}
                </p>
            </div>
            <!-- 绑定按钮 -->
            <template v-if="!isPrivate">
                <div class="wework-account-menu">
                    <v-icon
                        v-popmenu:accountMenu.click
                        name="dot3"
                        class="wework-account-menu-entry"
                    />
                </div>
            </template>
        </div>
        <v-page-header level="section" :title="$t('通讯录')" />
        <div class="wework-account-card">
            <v-icon
                name="contact"
                class="wework-account-ico"
            />
            <div class="wework-account-res">
                <p
                    :class="hasContactError ? 'wework-account-tit-err' : ''"
                    class="wework-account-tit"
                >
                    <v-icon
                        v-if="hasContactError"
                        name="v-error"
                    />
                    {{ contactStatusTxt }}
                </p>
                <secret-sync-rule
                    ref="secretSyncRule"
                    v-bind="$attrs"
                    :is-new="isNew"
                    @statusChange="onContactStatusChange"
                />
            </div>
            <!-- 绑定按钮 -->
            <template v-if="!isPrivate">
                <div
                    v-if="!hasContactError"
                    class="wework-account-menu wework-account-menu-contact"
                >
                    <v-icon
                        v-popmenu:contactMenu.click
                        name="dot3"
                        class="wework-account-menu-entry"
                    />
                </div>
            </template>
        </div>

        <steps-head
            v-if="showConversation"
            :title="$t('会话内容存档')"
        />
        <div
            v-if="showConversation"
            class="wework-account-card"
        >
            <v-icon
                name="conversation"
                class="wework-account-ico"
            />
            <div class="wework-account-res">
                <p class="wework-account-tit">
                    {{ conversationTit }}
                </p>
                <div class="wework-account-desc">
                    <ul>
                        <li>{{ conversationDesc }}</li>
                    </ul>
                    <v-button
                        v-if="!hasSetConversation"
                        @click="jumpConversation"
                        status="primary"
                        class="wework-account-btn"
                    >
                        {{ $t('立即配置') }}
                    </v-button>
                </div>
            </div>
            <div
                v-if="hasSetConversation"
                class="wework-account-menu wework-account-menu-contact"
            >
                <v-icon
                    v-popmenu:conversationMenu.click
                    name="dot3"
                    class="wework-account-menu-entry"
                />
            </div>
        </div>
        <mobile-validate-dialog
            ref="unBindDialog"
            @verify="onUnBindMobileVerify"
            :confirm-title="$t('解除企业微信的绑定？')"
            :confirm-btn-txt="$t('解除绑定')"
        >
            <div slot="content">
                <div>{{ $t('解除绑定后，将无法在企业微信上使用企点的服务') }}</div>
                <div>
                    {{ $t('解除绑定前，请在企业') }}
                    <i18n-t path="{site}删除所有已安装应用。" tag="span">
                        <a
                            slot="site"
                            @click="externalJump('https://work.weixin.qq.com/wework_admin/frame')"
                            style="cursor: pointer;"
                        >{{ $t('微信管理后台') }}</a>
                    </i18n-t>
                </div>
            </div>
        </mobile-validate-dialog>
        <mobile-validate-dialog
            ref="unAuthDialog"
            :cust-confirm-click="isNew"
            @verify="onUnAuthMobileVerify"
            @confirmClick="onUnAuthConfirmClick"
            :confirm-title="$t('确认解除企业微信通讯录的授权？')"
            :confirm-btn-txt="$t('解除授权')"
        >
            <div
                slot="content"
                class="unAuth-dialog-content"
            >
                {{ unAuthDesc.desc }}
                <p>{{ unAuthDesc.warn }}</p>
            </div>
        </mobile-validate-dialog>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import Gateway from '@/utils/Gateway';
import { hasPackages } from '@/utils/package';
import { showDialog, addDialogClass } from 'src/pages/mng/third_account/weworkCombine/api/dialog.js';
import getCorpInfo from '@/pages/mng/third_account/weworkCombine/api/getCorpInfo';
import { isPrivate } from 'src/config/private';
import StepsHead from '../../steps-head';
import SecretSyncRule from '../../secret-sync-rule';
import MobileValidateDialog from '../../mobile-validate-dialog';
import getBindInfo from '@/cgi/getBindInfo';


const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    components: {
        StepsHead,
        SecretSyncRule,
        MobileValidateDialog,
    },

    data() {
        return {
            hasGetData: false,
            isBind: true,
            accountInfo: {},
            accountMenuOptions: [{ text: this.$t('解除绑定'), value: 'unbind' }],
            contactMenuOptions: [{ text: this.$t('解除授权'), value: 'unauth' }],
            conversationOptions: [{ text: this.$t('编辑配置参数'), value: 'conversationEdit' }],
            hasContactError: true,
            contactStatusTxt: '',
            isNew: false,
            unAuthDesc: {},
            isPrivate,
            is_probation: true,
            showConversation: false,
            hasSetConversation: false,
        };
    },

    computed: {
        conversationTit() {
            return this.hasSetConversation
                ? this.$t('已配置会话内容存档')
                : this.$t('配置会话内容存档，可同步企业微信员工和客户的聊天内容，并做质检分析');
        },

        conversationDesc() {
            return this.hasSetConversation
                ? this.$t('可同步企业微信员工和客户的聊天内容，并做质检分析')
                : this.$t('配置前请确保已在企业微信上购买过会话内容存档');
        },
    },

    created() {
        this.getAccountInfo();
        this.getWeixinInfo();
    },

    methods: {
        externalJump(path) {
            window.open(path, '_blank');
        },
        getAccountInfo() {
            getCorpInfo()
                .then((res) => {
                    const { isBind, corpInfo, isNew } = res || {};

                    this.isBind = isBind;
                    this.accountInfo = corpInfo || {};
                    this.isNew = isNew;
                    this.hasGetData = true;


                    // this.getWxkfAuthUrl(isClick);
                    // this.getInstallUrl();
                })
                .catch((message) => {
                    this.$message.error(message || this.$t('获取企业微信账号信息失败'));
                });
        },

        unBindReq(code) {
            return Gateway.post('/v1/basic/corp/wework/DeleteCorpInfo', {
                corp_id: this.accountInfo.corp_id,
                verify_code: code,
            });
        },

        onMenuSelect(data) {
            const { option } = data || {};
            const { value } = option || {};

            if (value === 'unbind') {
                if (this.is_probation == true) {
                    this.$refs.unBindDialog.showConfirm();
                }
            } else if (value === 'unauth') {
                this.$refs.unAuthDialog.showConfirm();
            } else if (value === 'conversationEdit') {
                this.jumpConversation();
            }
        },

        unAuthReq(code) {
            return Gateway.post('/v1/wework/SetSyncStatus', {
                verify_code: code,
                sync_status: 1,
            });
        },

        onContactStatusChange(options) {
            const { status, hasContactError, contactStatusTxt } = options;
            this.hasContactError = hasContactError;
            this.contactStatusTxt = contactStatusTxt;

            if (status === 'manual') {
                this.unAuthDesc = {
                    desc: this.$t('解除授权后，将无法把企业微信员工导入到企点'),
                };
            } else if (status === 'all') {
                this.unAuthDesc = {
                    desc: this.$t('解除授权后，企业微信员工将不会再同步到企点'),
                    warn: this.$t('如果要再次开启"完全同步企业微信的通讯录至企点"，需要先删除企点组织架构中的所有员工'),
                };
            }

            this.getConversationConfig();
        },

        onUnAuthConfirmClick() {
            // this.$message
            const dialog = showDialog({
                title: this.$t('如果要解除企业微信通讯录的授权，请前往企业微信后台删除「腾讯企点客服」应用'),

                // eslint-disable-next-line no-unused-vars
                render(h) {
                    return <div class="unauth-guide-img"></div>;
                },
                confirmText: this.$t('前往企业微信后台'),
                // cancelText: '我已退出',
                confirm: () => {
                    window.open('https://work.weixin.qq.com/wework_admin/frame#apps');

                    this.$confirm({
                        title: this.$t('是否已删除「腾讯企点客服」应用？'),
                        confirmText: this.$t('已删除'),
                        cancelText: this.$t('还未删除'),
                        confirm: () => {
                            this.$refs.secretSyncRule.getInsteadResult();
                            // window.location.reload();
                        },
                    });
                },
            });

            addDialogClass(dialog, 'unauth-guide-dialog');
        },

        onUnBindMobileVerify(code) {
            this.$refs.unBindDialog.showVerifyLoading();
            this.unBindReq(code)
                .then(() => {
                    this.$message.success(this.$t('解除绑定成功'));
                    this.$refs.unBindDialog.hideVerify();
                    window.location.reload();
                })
                .catch((message) => {
                    const errMsg = message || this.$t('解除绑定失败');
                    this.$message.error(errMsg);
                    this.$refs.unBindDialog.hideVerifyLoading();
                    this.$refs.unBindDialog.showVerifyError(errMsg);
                });
        },

        onUnAuthMobileVerify(code) {
            this.$refs.unBindDialog.showVerifyLoading();
            this.unAuthReq(code)
                .then(() => {
                    this.$message.success(this.$t('解除授权成功'));
                    this.$refs.unBindDialog.hideVerify();
                    window.location.reload();
                })
                .catch((message) => {
                    const errMsg = message || this.$t('解除绑定失败');
                    this.$message.error(errMsg);
                    this.$refs.unBindDialog.hideVerifyLoading();
                    this.$refs.unBindDialog.showVerifyError(errMsg);
                });
        },

        getWeixinInfo() {
            getBindInfo()
                .then((res) => {
                    this.is_probation = res.bindInfo.is_probation || '';
                })
                .catch((message) => {
                    const errMsg = message || this.$t('获取信息失败');
                    this.$message.error(errMsg);
                });
        },
        getConversationConfig() {
            // 只有通过代开发应用绑定通讯录的授权了并且是客户通套餐才能够出现会话内容存档模块
            if (this.isNew && !this.hasContactError && hasPackages([10051, 10153, 18910, 18911, 18912])) {
                Gateway.get('/v1/basic/corp/wework/session').then((data) => {
                    const { secret } = data || {};

                    if (secret) {
                        this.hasSetConversation = true;
                    } else {
                        this.hasSetConversation = false;
                    }

                    this.showConversation = true;
                });
            }
        },

        jumpConversation() {
            this.$router.push('/mng/weworkAccount/index/conversation');
        },
    },
};
</script>
<style scoped lang="less">
@import './tab-account.less';
</style>
<style lang="less">
.unauth-guide-dialog {
    .v-dialog__title {
        white-space: pre-wrap;
        font-size: 24px;
        line-height: 34px;
    }
}
.unauth-guide-img {
    width: 480px;
    height: 240px;
    background: url(./assets/wework-admin.png);
}
</style>
